<app-page-header [title]="'Sample Type Details'"
                 [subtitle]="'View details of the selected sample type'"></app-page-header>
<div class="mb-5">
    <h2>{{ sampleType?.name }}</h2>
    <p><strong>ID:</strong> {{ sampleType?.id }}</p>
    <p><strong>DEP Intro Text:</strong> {{ sampleType?.depIntroText }}</p>
    <p><strong>Default Weight:</strong>
        {{ sampleType?.defaultWeight !== null ? sampleType?.defaultWeight + 'g' : '' }}
    </p>
    <p><strong>Created By:</strong> {{ sampleType?.createdBy | roleName }}</p>
    <p><strong>Updated By:</strong> {{ sampleType?.updatedBy | roleName }}</p>
</div>

<!-- Sample Type Categories -->
<div class="mb-6">
    <h2 class="text-2xl font-semibold mb-2">Categories</h2>
    <div class="border border-gray-300 dark:border-gray-700 p-4 rounded-md">
        @if (sampleCategories.length) {
            <div class="mb-4">
                <p-table [paginator]="false" [value]="sampleCategories">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Name</th>
                            <th>Default Weight</th>
                            <th>Tariff Code</th>
                            <th></th>
                        </tr>
                    </ng-template>
                    <ng-template let-category pTemplate="body">
                        <tr>
                            <td>{{ category.name }}</td>
                            <td>{{ category.defaultWeight !== null ? category.defaultWeight + 'g' : '' }}</td>
                            <td>{{ category.tariffCode }}</td>
                            <td>
                                <div class="flex justify-end gap-2">
                                    <p-button icon="pi pi-eye" pTooltip="View sample category"
                                              routerLink="/sample-types/sample-category/{{ category.id }}"
                                              text
                                              tooltipPosition="left"></p-button>
                                    <p-button (click)="editCategory(category)" icon="pi pi-pencil"
                                              canManageSampleDefinitions
                                              pTooltip="Edit category"
                                              text
                                              tooltipPosition="left"></p-button>
                                    <p-button (click)="deleteCategory(category)" icon="pi pi-trash"
                                              canManageSampleDefinitions
                                              pTooltip="Delete category"
                                              severity="danger"
                                              text
                                              tooltipPosition="left"></p-button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        }
        <p-button label="Add Category" icon="pi pi-plus" (click)="openCreateCategoryDialog()" canManageSampleDefinitions
                  [hidden]="false"></p-button>
    </div>
</div>

<div class="flex justify-between gap-2">
    <div>
        <p-button (click)="openEditDialog()" icon="pi pi-pencil" canManageSampleDefinitions label="Edit" text></p-button>
        <p-button (click)="confirmDelete()" icon="pi pi-trash" canManageSampleDefinitions label="Delete" severity="danger" text></p-button>
    </div>
    <p-button label="Back to Sample Types" icon="pi pi-arrow-left" routerLink="/sample-types"></p-button>
</div>

<!-- Update Dialog -->
<app-update-sample-type-dialog
        [(visible)]="displayUpdateDialog"
        [sampleType]="editableSampleType"
        (sampleTypeUpdated)="reloadSampleTypeDetails()"
></app-update-sample-type-dialog>

<app-create-sample-category-dialog
        [sampleTypeId]="this.sampleType?.id || 0"
        [(visible)]="displayCreateCategoryDialog"
        (sampleCategoryCreated)="reloadSampleTypeDetails()"></app-create-sample-category-dialog>

<app-update-sample-category-dialog
        [(visible)]="displayUpdateCategoryDialog"
        [sampleCategory]="editableSampleCategory"
        (sampleCategoryUpdated)="reloadSampleTypeDetails()"></app-update-sample-category-dialog>
